'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _itemTypeToComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUltimatePagination = require('react-ultimate-pagination');

var _FlatButton = require('material-ui/FlatButton');

var _FlatButton2 = _interopRequireDefault(_FlatButton);

var _firstPage = require('material-ui/svg-icons/navigation/first-page');

var _firstPage2 = _interopRequireDefault(_firstPage);

var _lastPage = require('material-ui/svg-icons/navigation/last-page');

var _lastPage2 = _interopRequireDefault(_lastPage);

var _chevronLeft = require('material-ui/svg-icons/navigation/chevron-left');

var _chevronLeft2 = _interopRequireDefault(_chevronLeft);

var _chevronRight = require('material-ui/svg-icons/navigation/chevron-right');

var _chevronRight2 = _interopRequireDefault(_chevronRight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var flatButtonStyle = {
  minWidth: 36
};

var Page = function Page(_ref) {
  var value = _ref.value,
      isActive = _ref.isActive,
      onClick = _ref.onClick,
      isDisabled = _ref.isDisabled;
  return _react2.default.createElement(_FlatButton2.default, {
    style: flatButtonStyle,
    label: value.toString(),
    primary: isActive,
    onClick: onClick,
    disabled: isDisabled
  });
};

var Ellipsis = function Ellipsis(_ref2) {
  var onClick = _ref2.onClick,
      isDisabled = _ref2.isDisabled;
  return _react2.default.createElement(_FlatButton2.default, {
    style: flatButtonStyle,
    label: '...',
    onClick: onClick,
    disabled: isDisabled
  });
};

var FirstPageLink = function FirstPageLink(_ref3) {
  var isActive = _ref3.isActive,
      onClick = _ref3.onClick,
      isDisabled = _ref3.isDisabled;
  return _react2.default.createElement(_FlatButton2.default, {
    style: flatButtonStyle,
    icon: _react2.default.createElement(_firstPage2.default, null),
    onClick: onClick,
    disabled: isDisabled
  });
};

var PreviousPageLink = function PreviousPageLink(_ref4) {
  var isActive = _ref4.isActive,
      onClick = _ref4.onClick,
      isDisabled = _ref4.isDisabled;
  return _react2.default.createElement(_FlatButton2.default, {
    style: flatButtonStyle,
    icon: _react2.default.createElement(_chevronLeft2.default, null),
    onClick: onClick,
    disabled: isDisabled
  });
};

var NextPageLink = function NextPageLink(_ref5) {
  var isActive = _ref5.isActive,
      onClick = _ref5.onClick,
      isDisabled = _ref5.isDisabled;
  return _react2.default.createElement(_FlatButton2.default, {
    style: flatButtonStyle,
    icon: _react2.default.createElement(_chevronRight2.default, null),
    onClick: onClick,
    disabled: isDisabled
  });
};

var LastPageLink = function LastPageLink(_ref6) {
  var isActive = _ref6.isActive,
      onClick = _ref6.onClick,
      isDisabled = _ref6.isDisabled;
  return _react2.default.createElement(_FlatButton2.default, {
    style: flatButtonStyle,
    icon: _react2.default.createElement(_lastPage2.default, null),
    onClick: onClick,
    disabled: isDisabled
  });
};

var itemTypeToComponent = (_itemTypeToComponent = {}, _defineProperty(_itemTypeToComponent, _reactUltimatePagination.ITEM_TYPES.PAGE, Page), _defineProperty(_itemTypeToComponent, _reactUltimatePagination.ITEM_TYPES.ELLIPSIS, Ellipsis), _defineProperty(_itemTypeToComponent, _reactUltimatePagination.ITEM_TYPES.FIRST_PAGE_LINK, FirstPageLink), _defineProperty(_itemTypeToComponent, _reactUltimatePagination.ITEM_TYPES.PREVIOUS_PAGE_LINK, PreviousPageLink), _defineProperty(_itemTypeToComponent, _reactUltimatePagination.ITEM_TYPES.NEXT_PAGE_LINK, NextPageLink), _defineProperty(_itemTypeToComponent, _reactUltimatePagination.ITEM_TYPES.LAST_PAGE_LINK, LastPageLink), _itemTypeToComponent);

var UltimatePaginationMaterialUi = (0, _reactUltimatePagination.createUltimatePagination)({ itemTypeToComponent: itemTypeToComponent });

exports.default = UltimatePaginationMaterialUi;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-ultimate-pagination-material-ui/lib/react-ultimate-pagination-material-ui.js
// module id = 244
// module chunks = 0